
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/using-transfer-ui",
      function () {
        return require("private-next-pages/docs/transfer/using-transfer-ui.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/using-transfer-ui"])
      });
    }
  